﻿import HotEditableFormAction_ from "../modules/vue/hotEditable/HotEditableFormAction";
import common from "../common";
import AjaxService_ from "./AjaxService";
import context_ from "../modules/context";
import config_ from "../modules/config";
import utilities_ from "../modules/utilities";
import core from "../core";

const context = require("../modules/context") as typeof context_;
const config = require("../modules/config") as typeof config_;
const utilities = require("../modules/utilities") as typeof utilities_;
// const AjaxService = require("./AjaxService") as AjaxService_;
// const HotEditableFormAction = require("../modules/vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;

class FormService {

    private _ajaxService: AjaxService_;
    private _formsContainerTarget = ".mod-page .mp-content";

    constructor(public formName?: string | null, formsContainerTarget?: string) {
        formName = formName ?? utilities.createGuid("N");

        if (formsContainerTarget || formsContainerTarget === '')
            this._formsContainerTarget = formsContainerTarget;

        this._ajaxService = new AjaxService_();
    }

    actionHasError(action: HotEditableFormAction_) {
        const hasError = action.hasErrors();

        if (hasError) {
            const errors = action.getErrors();
            this.displayErrorsImediately(errors);
        }

        return hasError;
    }

    /** Post Ajax de base */
    post(
        url: string,
        postArgument?: any,
        onSuccess?: (responseData: any) => void,
        onError?: (errors: common.IError[], config?: common.IHotEditableFormConfig) => void,
        onBefore?: () => void,
        onAfter?: (isSuccess: boolean) => void) {
        this._ajaxService.post(url, postArgument, true, onSuccess, onError, onBefore, onAfter);
        return this;
    }

    /** Permet de poster le formulaire */
    validateAndPost(
        apiUrl?: string | null,
        validate?: (() => common.IError[]) | null,
        defaultArgs?: {},
        onSuccess?: (data: any) => void,
        onError?: (e: common.IError[], config?: common.IHotEditableFormConfig) => void,
        lockScreenDuringPost?: boolean | null,
        postFormData?: boolean,
        closeMessagesFromAllForms?: boolean,
        otherMessagesToCloseByFormNames?: string[]) {

        lockScreenDuringPost = lockScreenDuringPost !== false;// default is TRUE
        postFormData = postFormData !== false// default is TRUE
        closeMessagesFromAllForms = closeMessagesFromAllForms !== false;// default is TRUE

        if (!apiUrl)
            throw "[FormService::ValidateAndPost] L'argument 'apiUrl' est requis.";

        if (lockScreenDuringPost)
            this.lockScreen();

        const errors = (validate ? validate() : null) || [];
        const isValid = !errors.length;
        const manager = context.components.getMessagesManager();

        const messageSourcesToClose = [this.formName];
        if (closeMessagesFromAllForms || otherMessagesToCloseByFormNames) {

            const appendMessageSource = (s: string | null) => {
                for (let i = 0; i < messageSourcesToClose.length; i++)
                    if (messageSourcesToClose[i] === s)
                        return;
                messageSourcesToClose.push(s);
            };
            if (otherMessagesToCloseByFormNames) {
                for (let i = 0; i < otherMessagesToCloseByFormNames.length; i++) {
                    const n = otherMessagesToCloseByFormNames[i];
                    appendMessageSource(n);
                }
            }

            if (closeMessagesFromAllForms) {
                const otherForms = $((this._formsContainerTarget ? this._formsContainerTarget + ' ' : '') + "form[name]:not([name='" + this.formName + "'])");
                for (let i = 0; i < otherForms.length; i++) {
                    const f = otherForms[i];
                    const n = f.getAttribute('name');
                    appendMessageSource(n);
                }
            }
        }

        for (let i = 0; i < messageSourcesToClose.length; i++)
            manager.closeBySource(messageSourcesToClose[i]);

        if (isValid) {
            const formTarget = postFormData ? "form[name='" + this.formName + "']" : null;
            const postedArguments = this._ajaxService.postForm(apiUrl, formTarget, defaultArgs || null, true,
                data => {
                    if (onSuccess)
                        onSuccess(data);
                    this.unlockScreen();
                },
                (errors, c) => {
                    errors = errors || [];

                    // gestion de la concurrance et des acces non-authorises
                    var concurrancyError = null as common.IError | null;
                    var unauthorizedError = null as common.IError | null;

                    for (let i = 0; i < errors.length; i++) {
                        const e = errors[i];

                        if (!e)
                            continue;

                        if (e.code === config.errors.codes.unauthorized) {
                            unauthorizedError = e;
                            break;
                        } else if (e.code === config.errors.codes.concurrency) {
                            concurrancyError = e;
                            break;
                        }

                    }

                    if (unauthorizedError || concurrancyError) {
                        const m = context.components.getMessagesManager();

                        if (unauthorizedError) {
                            m.displayErrorAsMessage(unauthorizedError, this.formName, false);
                            utilities.redirect('/');
                            return;
                        } else if (concurrancyError) {
                            m.displayErrorAsMessage(concurrancyError, this.formName, false);
                            utilities.refresh();
                            return;
                        }

                    } else {
                        if (onError)
                            onError(errors, c);
                    }

                    this.unlockScreen();
                });

            return postedArguments;
        }

        if (onError)
            onError(errors);

        this.unlockScreen();

        return null;
    }

    private lockScreen() {
        context.components.getPage().lockScreen();
    }

    private unlockScreen() {
        context.components.getPage().unlockScreen();
    }

    /** Retournera 'TRUE' si la popup s'ouvre. */
    public confirm(confirmationPopup: core.ConfirmationPopup, confirmationMessages?: common.IHotEditableFormConfirmationMessage[], acceptedAction?: () => void, deniedAction?: (returnToApiOnDenied: boolean) => void) {
        return FormService.confirm(this.formName, confirmationPopup, confirmationMessages, acceptedAction, deniedAction);
    }
    /** Retournera 'TRUE' si la popup s'ouvre. */
    public static confirm(formName?: string | null, confirmationPopup?: core.ConfirmationPopup | null, confirmationMessages?: common.IHotEditableFormConfirmationMessage[] | null, acceptedAction?: () => void, deniedAction?: (returnToApiOnDenied: boolean) => void) {

        if (!confirmationMessages || !confirmationMessages.length)
            return false;

        interface IMessageData {
            field: HTMLInputElement,
            message: common.IHotEditableFormConfirmationMessage
        }

        /** retournera le input sil s'agit de la creation du input initial */
        const updateField = (field: HTMLInputElement, confirmationMessage: common.IHotEditableFormConfirmationMessage, value?: string) => {
            value = value || common.ConfirmationCodes.unset;

            if (field) {
                field.value = value;
                return null;
            }

            // Injection du hidden field
            const form = document.getElementsByName(formName as string)[0];
            field = document.createElement("input") as HTMLInputElement;
            field.setAttribute("type", "hidden");
            field.id = confirmationMessage.key;
            field.name = confirmationMessage.key;
            field.value = value;

            form.appendChild(field);

            return field;
        };

        const getField = (m: common.IHotEditableFormConfirmationMessage) => document.getElementById(m.key) as HTMLInputElement;
        const onEachConfirmationMessages = (action: (m: common.IHotEditableFormConfirmationMessage, f: HTMLInputElement, isFirst: boolean, isLast: boolean) => void) => {
            const r = [] as IMessageData[];
            const f = (i: number) => {
                const m = confirmationMessages[i];
                const f = getField(m);
                action(m, f, i === 0, i === confirmationMessages.length - 1);
                r.push({
                    field: f,
                    message: m
                });
            };

            for (let i = 0; i < confirmationMessages.length; i++)
                f(i);

            return r;
        };

        // Reset
        const lastIndex = confirmationMessages.length - 1;
        const lastMessage = confirmationMessages[lastIndex];

        const cascadeReset = () => {

            // reseter tout ce qui est anterieur au dernier 'reset'.
            onEachConfirmationMessages((m, f) => {
                if (m.reset)
                    updateField(f, m)
            });
            return true;
        }

        if (lastMessage.validated) {
            cascadeReset();
            return;
        }

        // Popup
        confirmationPopup?.show(
            lastMessage.titleHtml,
            lastMessage.contentHtml,
            () => {
                // OUI
                updateField(getField(lastMessage), lastMessage, common.ConfirmationCodes.accepted);

                if (acceptedAction)
                    acceptedAction();
            },
            () => {
                // NON
                updateField(getField(lastMessage), lastMessage, common.ConfirmationCodes.denied);

                var returnToApiOnDenied = !!lastMessage.returnToApiOnDenied;

                if (deniedAction)
                    deniedAction(returnToApiOnDenied);

                if (!returnToApiOnDenied)
                    cascadeReset();
            },
            lastMessage.hideDeniedButton);

        return true;
    }

    /** Bati un message a partir d'une action de formulaire */
    buildAjaxUpdateSuccessMessage(action: HotEditableFormAction_, liveUpdateOnEditMode?: boolean) {

        if (action.isFieldChanged() && (!action.isEditionFormMode() || liveUpdateOnEditMode)) {
            const displayName = action.getFieldDisplayName();
            return displayName
                ? "Le champ '{0}' a été mis à jour.".replace('{0}', displayName)
                : "Le champ a été mis à jour.";
        }

        if (action.getActionType() === common.HotEditableActionTypes.update)
            return "L'enregistrement a été effectué avec succès";

        if (action.getActionType() === common.HotEditableActionTypes.cancel)
            return "L'annulation a été effectuée avec succès";

        if (action.getActionType() === common.HotEditableActionTypes.delete)
            return "La suppression a été effectuée avec succès";

        if (action.getActionType() === common.HotEditableActionTypes.create)
            return "La création a été effectuée avec succès";

        return null;
    }

    /**
     * @param autoClose default is FALSE
     */
    displaySuccessMessageFromAction(action: HotEditableFormAction_, immediateDisplay: boolean, autoClose?: boolean, liveUpdateOnEditMode?: boolean) {
        autoClose = autoClose === true;//default is FALSE
        const message = this.buildAjaxUpdateSuccessMessage(action, liveUpdateOnEditMode);
        if (message)
            this.displayMessage(message, common.MessageTypes.success, immediateDisplay, autoClose);
        return this;
    }

    /**
     * @param autoClose default is FALSE
     */
    displayMessage(message: string, messageType: common.MessageTypes, immediateDisplay: boolean, autoClose?: boolean) {
        autoClose = autoClose === true;//default is FALSE

        if (!message)
            throw "L'argument 'message' est requis.";

        if (!messageType)
            throw "L'argument 'messageType' est requis.";

        const manager = context.components.getMessagesManager();
        const m = {
            title: this.buildTitleFromMessageType(messageType),
            contentHtml: message,
            autoClose: autoClose || null,
            messageSource: this.formName,
            messageType: messageType || null
        } as common.IMessage;

        manager.displayMessage(m, immediateDisplay);

        return this;
    }

    /** 
     * @param autoClose default is FALSE
     */
    displayNotSavedErrorMessageImediately(autoClose?: boolean) {
        autoClose = autoClose === true;//default is FALSE
        this.displayMessage(config.messages.getNotSavedMessage(), common.MessageTypes.error, true, autoClose);
        return this;
    }

    /**
     * @param autoClose default is FALSE
     */
    displayErrorImediately(error: common.IError, autoClose?: boolean) {
        autoClose = autoClose === true;//default is FALSE
        this.displayErrorsImediately([error], autoClose);

        return this;
    }

    /**
     * @param autoClose default is FALSE
     */
    displayErrorsImediately(errors: common.IError[], autoClose?: boolean) {
        autoClose = autoClose === true;//default is FALSE
        const manager = context.components.getMessagesManager();
        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];
            const source = this.formName;
            manager.displayErrorAsMessage(error, source, true, autoClose);
        }

        return this;
    }

    private buildTitleFromMessageType(messageType?: common.MessageTypes) {

        if (messageType) {
            if (messageType === common.MessageTypes.success)
                return config.messages.defaultTitles.success();

            if (messageType === common.MessageTypes.info)
                return config.messages.defaultTitles.info();

            if (messageType === common.MessageTypes.warning)
                return config.messages.defaultTitles.warning();

            if (messageType === common.MessageTypes.error)
                return config.messages.defaultTitles.error();
        }

        return '';
    }
}

export = FormService;